import { apiClient } from '@/lib/api/api-client'
import { CreateUserModel, UpdateUserDepartmentsModel, User, UserDetail } from '../types/user'

const USER_ENDPOINT = '/users'

export const userApi = {
  getUsers: (role?: string) => {
    return apiClient.get<User[]>(USER_ENDPOINT, {
      params: role ? { role } : undefined,
    })
  },

  getUserById: (id: string) => {
    return apiClient.get<UserDetail>(`${USER_ENDPOINT}/${id}`)
  },

  createUser: (payload: CreateUserModel) => {
    return apiClient.post<User>(USER_ENDPOINT, payload)
  },

  updateUser: (id: string, payload: Partial<CreateUserModel>) => {
    return apiClient.put<User>(`${USER_ENDPOINT}/${id}`, payload)
  },

  updateUserDepartments: (id: string, payload: UpdateUserDepartmentsModel) => {
    return apiClient.put<UserDetail>(`${USER_ENDPOINT}/${id}/departments`, payload)
  },

  deleteUser: (id: string) => {
    return apiClient.delete<void>(`${USER_ENDPOINT}/${id}`)
  },
}
